export const getAudioByUrl = (soundFileUrl, handlePlaybackFinished, handleLoadedMetadata) => {
    const audio = new Audio(soundFileUrl);
    audio.addEventListener('loadedmetadata', handleLoadedMetadata);
    audio.addEventListener('ended', handlePlaybackFinished);

    return audio;
}